import { Button } from "@octopusdeploy/design-system-components";
import { ArrowUpRightFromSquareIcon } from "@octopusdeploy/design-system-icons";
import * as React from "react";
import type { RenderProps } from "~/components/Dialog/CustomDialog";
import { CustomDialogActions } from "./CustomDialogActions";
import { CustomDialogContent } from "./CustomDialogContent";
import type { DialogFrameProp } from "./CustomDialogFrames";
import { LargeDialogFrame } from "./CustomDialogFrames";
import { CustomDialogTitleBar } from "./CustomDialogTitleBar";
export type CustomExternalLinkDialogLayoutProps = RenderProps & DialogFrameProp & {
    title: string;
    externalLink: string;
    externalLinkLabel: string;
    closeButtonLabel?: string;
    additionalActions?: React.ReactNode;
    dispatchAnalytics?: () => void;
    children?: React.ReactNode;
};
export const CustomExternalLinkDialogLayout: React.FC<CustomExternalLinkDialogLayoutProps> = ({ closeButtonLabel = "Close", children, title, externalLink, externalLinkLabel, close, frame: Frame = LargeDialogFrame, additionalActions, dispatchAnalytics, }) => {
    return (<Frame>
            <CustomDialogTitleBar title={title}/>
            <CustomDialogContent>{children}</CustomDialogContent>
            <CustomDialogActions actions={<React.Fragment>
                        {additionalActions}
                        <Button key="close" onClick={close} label={closeButtonLabel} importance="secondary"/>
                        <Button key="link" onClick={(event) => {
                event.preventDefault();
                window.open(externalLink, "_blank");
                dispatchAnalytics?.();
            }} label={externalLinkLabel} importance="primary" icon={<ArrowUpRightFromSquareIcon size={20}/>}/>
                    </React.Fragment>}/>
        </Frame>);
};
CustomExternalLinkDialogLayout.displayName = "CustomExternalLinkDialogLayout"
export default CustomExternalLinkDialogLayout;
